import type { PosSettings } from "@/actions/ssr/getOnlineOrderSettingsSSR";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface OnlineOrderSettingsState {
  settings: PosSettings | null;
  isLoading: boolean;
}

const initialState: OnlineOrderSettingsState = {
  settings: null,
  isLoading: false,
};

export const onlineOrderSettingsSlice = createSlice({
  name: "onlineOrderSettings",
  initialState,
  reducers: {
    setOnlineOrderSettings: (state, action: PayloadAction<PosSettings>) => {
      state.settings = action.payload;
    },
    setOnlineOrderSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setOnlineOrderSettings, setOnlineOrderSettingsLoading } =
  onlineOrderSettingsSlice.actions;

export default onlineOrderSettingsSlice.reducer;
